import React, { useState, useEffect } from "react";
import axios from "axios";
import { T } from "../context/LanguageContext";
import { ListenButton } from "./ListenButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PageHero = ({ topic, title, subtitle, listenTargetId }) => {
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    axios.get(`${API}/photo`, { params: { topic } }).then((r) => setPhoto(r.data)).catch(() => {});
  }, [topic]);

  return (
    <div className="relative overflow-hidden bg-blue-50" data-testid="page-hero">
      {photo && (
        <img src={photo.image_url} alt={topic} className="absolute inset-0 h-full w-full object-cover opacity-30" />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/75 to-blue-100/40" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <h1 className="max-w-3xl text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          <T>{title}</T>
        </h1>
        <p className="mt-4 max-w-2xl text-base text-slate-600 sm:text-lg"><T>{subtitle}</T></p>
        <div className="mt-6">
          <ListenButton targetId={listenTargetId} />
        </div>
        {photo && (
          <p className="mt-6 text-xs text-slate-500" data-testid="photo-attribution">
            Photo by{" "}
            <a href={photo.attribution.photographer_url} target="_blank" rel="noreferrer" className="underline hover:text-[#0055FF]">
              {photo.attribution.photographer_name}
            </a>{" "}
            on{" "}
            <a href={photo.attribution.unsplash_url} target="_blank" rel="noreferrer" className="underline hover:text-[#0055FF]">
              Unsplash
            </a>
          </p>
        )}
      </div>
    </div>
  );
};
